import { COUNTRY_CURRENCY_EVOLUTION } from "../constants/currency";
import { UserState } from "../redux/user/slice";
import { getLocalStorageItem } from "./localStorage";
import { STORAGE_USER_COUNTRY } from "../constants/variables";

export const checkCountry = async (userData: UserState) => {
  const userCountry = getLocalStorageItem(STORAGE_USER_COUNTRY);
  if (userCountry) {
    return userData.currency !== COUNTRY_CURRENCY_EVOLUTION[userCountry];
  }
  return false;
};
